export default __webpack_public_path__ + "static/media/metamask-network-mainnet.8c0f3928.png";